import { render, staticRenderFns } from "./consent-status-info.vue?vue&type=template&id=2f41ffbf"
import script from "./consent-status-info.vue?vue&type=script&lang=js"
export * from "./consent-status-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports